import "core-js/modules/es.array.find";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import useSizeTypeFromFragments from './useSizeTypeFromFragments';

var _ref2 = /*#__PURE__*/React.createElement(PhotoCameraIcon, {
  color: "inherit"
});

function ProductImageIframeComponent(_ref) {
  var alt = _ref.alt,
      mediaSizeMap = _ref.mediaSizeMap,
      shape = _ref.shape,
      shrink = _ref.shrink,
      size = _ref.size,
      src = _ref.src,
      rest = _objectWithoutProperties(_ref, ["alt", "mediaSizeMap", "shape", "shrink", "size", "src"]);

  var sizeType = useSizeTypeFromFragments(mediaSizeMap, size, shape, shrink);
  var theme = useTheme();

  if (!src) {
    return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
      title: alt,
      style: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[300],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }), _ref2);
  }

  var _ref3 = typeof src === 'string' ? [null, src] : src.find(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
        st = _ref6[0];

    return st === sizeType;
  }) || [],
      _ref4 = _slicedToArray(_ref3, 2),
      imgSrc = _ref4[1];

  return imgSrc ? /*#__PURE__*/React.createElement("iframe", _extends({}, pickHTMLProps(rest), {
    title: alt,
    src: imgSrc
  })) : null;
}

ProductImageIframeComponent.propTypes = {
  alt: PropTypes.string,
  mediaSizeMap: PropTypes.shape({}),
  shape: PropTypes.oneOf(['square', 'landscape', 'portrait', 'wide', 'tall']).isRequired,
  shrink: PropTypes.oneOf(['crop', 'fit']).isRequired,
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'big']).isRequired,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))])
};
ProductImageIframeComponent.defaultProps = {
  alt: undefined,
  mediaSizeMap: undefined,
  src: undefined
};
export default ProductImageIframeComponent;